/* eslint-disable @typescript-eslint/no-floating-promises */
/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect, useState } from 'react';
import { fetchJSON } from '../../../support/Fetch';
import {
  Vendor,
  VendorSummaryWithMarketsAndFields,
} from '../../../types/shared/Vendor';
import LoadingIndicator from '../../uiold/LoadingIndicator';
import { FileDesc } from '../../../types/shared/FileDesc';
import { HoverFieldType } from '../types';
import { VendorProfileTemplateType } from '../../../types/shared/Account';
import { getFileURL } from '../../../support/helpers/Files';
import { TouchableOpacity } from 'react-native';
import getCardTemplates from './CardTemplates';

function CardBase(props: {
  vendorID: string;
  vendorData?: VendorSummaryWithMarketsAndFields;
  selectedNameID: string;
  selectedImageID: string;
  selectedDescriptionID: string;
  accountID: string;
  hoverFieldType?: HoverFieldType | null;
  selectedCardOptionType: VendorProfileTemplateType;
  onClick?: () => void;
  nameColor: string;
  descriptionColor: string;
  backgroundColor: string;
}) {
  let {
    vendorID,
    vendorData,
    selectedNameID,
    selectedImageID,
    selectedDescriptionID,
    accountID,
    hoverFieldType,
    selectedCardOptionType,
    onClick,
    backgroundColor,
    nameColor,
    descriptionColor,
  } = props;
  let [vendor, setVendor] = useState<
    Vendor | VendorSummaryWithMarketsAndFields | null
  >(vendorData ?? null);
  let [fields, setFields] = useState({
    imageUrl: '',
    name: '',
    description: '',
  });
  let { imageUrl, name, description } = fields;

  useEffect(() => {
    if (!vendorData) {
      let url = `/api/vendors/${vendorID}`;
      fetchJSON(url, (error: Error | null | undefined, data: any) => {
        setVendor(data.vendor);
      });
    }
  }, [vendorID, vendorData]);

  useEffect(() => {
    if (vendor?.id) {
      let vendorFields = vendor?.fields;

      // TODO: Add Zod run-time validation to front end to verify fields
      let imageFieldValue = vendorFields?.find(
        (field) => field.id === selectedImageID,
      )?.value as FileDesc;
      let nameFieldValue = String(
        vendorFields?.find((field) => field.id === selectedNameID)?.value,
      );
      let descriptionFieldValue = String(
        vendorFields?.find((field) => field.id === selectedDescriptionID)
          ?.value,
      );
      let url = '';
      if (typeof imageFieldValue?.name === 'string') {
        url = getFileURL(imageFieldValue, { size: 'normal' });
      }
      setFields({
        imageUrl: url,
        name: nameFieldValue,
        description: descriptionFieldValue,
      });
    }
  }, [
    vendor,
    selectedImageID,
    accountID,
    selectedDescriptionID,
    selectedNameID,
  ]);

  if (!vendor?.fields) {
    <LoadingIndicator />;
  }

  let cardTemplates = getCardTemplates({
    name,
    imageUrl,
    description,
    hoverFieldType,
    backgroundColor,
    descriptionColor,
    nameColor,
  });

  return (
    <TouchableOpacity onPress={onClick}>
      {cardTemplates[selectedCardOptionType].component}
    </TouchableOpacity>
  );
}

export default CardBase;
